import { atom } from 'recoil';
import { IProgressStep } from '../components/Checkout/program/step/lib/application.util';
import { i18n } from 'lib/i18n';

const initialSteps: IProgressStep[] = [
	'package',
	{
		tabName: i18n.checkout.progress.teams,
		urlPath: 'league/teams',
	},
	'addons',
	{
		tabName: i18n.checkout.progress.familyMembers,
		urlPath: 'league/details',
	},
	{
		tabName: i18n.checkout.progress.application,
		urlPath: 'league/application',
	},
	'payment',
];
const Steps = atom<IProgressStep[]>({
	key: 'steps',
	default: initialSteps,
});

export const stepsStore = {
	Steps,
};
